import { useCallback, useEffect, useRef, useState } from "react";
import {useBaseApi} from "../useBaseApi";

export function useCities() {

    const [cities, setCities] = useState(null);
    const {search} = useBaseApi();
    const searchRef = useRef(search);

    useEffect(() => {
        searchRef.current = search;
    }, [search]);

    const loadCities = useCallback(async (provinceId) => {
        if(!provinceId){
            setCities(null);
            return;
        }

        let filters = [
            {field: "provinceId", operator: "=", value: provinceId},
        ];

        let response = await searchRef.current("/cities", filters, null, null, null, false);

        setCities(response.data);
    }, []);

    return [cities, loadCities];
}
